<template>
  <div class="public-layout">
    <slot />
  </div>
</template>

<script>
export default {
  mounted() {
    // document.body.classList.remove("dark-mode");
    // const self = this;
    // setTimeout(() => {
    //   self.$drift.show();
    // }, 3000);
  }
};
</script>

<style lang="scss">
.public-layout {
  min-height: 100vh;
}
</style>
